var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 34,
    viewBox: "0 0 45 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 0H0V33.8832H45V0Z",
    fill: "#D5D6D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7532 15.1797C25.7558 15.1797 17.5653 25.3402 16.5751 25.3402C15.7229 25.3402 12.337 20.2852 11.486 20.2852C10.6026 20.2852 -0.158913 31.0073 0.459219 33.8836H44.5674C42.545 31.3266 28.0435 15.1797 26.7544 15.1797H26.7532Z",
    fill: "#EEEFEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91212 12.0767C12.0015 12.0767 13.6953 10.3763 13.6953 8.27861C13.6953 6.18095 12.0015 4.48047 9.91212 4.48047C7.82271 4.48047 6.12891 6.18095 6.12891 8.27861C6.12891 10.3763 7.82271 12.0767 9.91212 12.0767Z",
    fill: "#ECEDED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultImage);
export default __webpack_public_path__ + "static/media/DefaultImage.40f83813ad8c06f872f072170a5ec729.svg";
export { ForwardRef as ReactComponent };